import { ReturnRepository } from "@domain/repositories/ReturnRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";

type Input = {
  clientId: Client["id"];
  operatorId: string;
};

type Output = Promise<Client>;

export class AssignReturnUseCase implements UseCase<Input, Output> {
  constructor(private readonly returnRepository: ReturnRepository) {}

  execute({ clientId, operatorId }: Input) {
    return this.returnRepository.assign(clientId, operatorId);
  }
}
